<script lang="ts">
  import InspectorField from '../InspectorField.svelte';
  import ConfirmDialog from '../../ui/ConfirmDialog.svelte';
  import { patchRCU, deleteRCU } from '$lib/api';
  import { clearEntity, selectEntity } from '$lib/router';
  import { rcusQuery } from '$lib/queries/rcus';
  import { dinModulesForUnitQuery } from '$lib/queries/din_modules';
  import { invalidateAfterRcuUpdate } from '$lib/state/invalidation';
  import { router } from '$lib/router';

  let { id }: { id: number } = $props();

  const rcus = rcusQuery();
  const dinModules = dinModulesForUnitQuery();

  let rcu = $derived((rcus.data ?? []).find((r) => r.id === id));
  let rcuDinModules = $derived(
    (dinModules.data ?? []).filter((m) => m.rcu === id).sort((a, b) => a.address - b.address)
  );

  let showDeleteConfirm = $state(false);

  async function saveName(name: string) {
    await patchRCU(id, { name });
    invalidateAfterRcuUpdate(router.unitId!);
  }

  async function saveChannelCount(value: string) {
    const channel_count = Number(value);
    if (!channel_count) throw new Error('Channel count is required');
    await patchRCU(id, { channel_count });
    invalidateAfterRcuUpdate(router.unitId!);
  }

  async function handleDelete() {
    showDeleteConfirm = false;
    if (!rcu) return;
    await deleteRCU(rcu.id);
    invalidateAfterRcuUpdate(router.unitId!);
    clearEntity();
  }
</script>

{#if rcu}
  <div class="px-3 py-3 space-y-4">
    <div class="space-y-2">
      <InspectorField label="Name" value={rcu.name} onSave={saveName} />

      <InspectorField
        label="Channel count"
        type="number"
        value={String(rcu.channel_count ?? '')}
        mono
        onSave={saveChannelCount}
      />

      <div class="space-y-1">
        <p class="text-2xs font-medium text-text-muted uppercase tracking-wide">DIN modules</p>
        {#if rcuDinModules.length === 0}
          <p class="text-sm text-text-muted">No DIN modules</p>
        {:else}
          <ul class="space-y-1">
            {#each rcuDinModules as mod}
              <li>
                <button
                  type="button"
                  class="w-full text-left px-2 py-1 text-sm rounded hover:bg-bg-hover transition-colors duration-100"
                  onclick={() => selectEntity('din', mod.id)}
                >
                  <span class="font-mono text-text-primary">{mod.address}</span>
                  <span class="text-text-secondary"> · {mod.module_type}</span>
                </button>
              </li>
            {/each}
          </ul>
        {/if}
      </div>
    </div>

    <div class="pt-4 border-t border-border-default space-y-2">
      <p class="text-2xs font-medium text-text-muted uppercase tracking-wide">Danger zone</p>
      <button
        type="button"
        class="w-full px-2 py-1.5 text-sm text-state-error border border-state-error/30 rounded hover:bg-state-error/5 transition-colors duration-100"
        onclick={() => (showDeleteConfirm = true)}
      >
        Delete RCU
      </button>
    </div>
  </div>
{:else}
  <div class="px-3 py-3 text-sm text-text-muted">RCU not found</div>
{/if}

<ConfirmDialog
  bind:open={showDeleteConfirm}
  title="Delete RCU"
  message="Delete “{rcu?.name}”? All DIN modules and channel assignments will be removed."
  confirmText="Delete"
  onconfirm={handleDelete}
  oncancel={() => (showDeleteConfirm = false)}
/>
